import { render, staticRenderFns } from "./AssistanceAssurances.vue?vue&type=template&id=2b682a6e&"
import script from "./AssistanceAssurances.js?vue&type=script&lang=js&"
export * from "./AssistanceAssurances.js?vue&type=script&lang=js&"
import style0 from "./AssistanceAssurances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports